import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const http = axios.create({ baseURL: API, withCredentials: true });
http.interceptors.request.use((c) => {
  const t = localStorage.getItem("v2max_token");
  if (t) c.headers.Authorization = `Bearer ${t}`;
  return c;
});

export const STATUS_META = {
  uj: { label: "Új", cls: "bg-blue-100 text-blue-700 border-blue-300" },
  kapcsolat: { label: "Felvettük a kapcsolatot", cls: "bg-amber-100 text-amber-700 border-amber-300" },
  ajanlat: { label: "Ajánlat kiküldve", cls: "bg-purple-100 text-purple-700 border-purple-300" },
  lezart: { label: "Lezárt", cls: "bg-green-100 text-green-700 border-green-300" },
};

export const SOURCE_META = {
  meta: { label: "Meta Ads", cls: "bg-sky-100 text-sky-700 border-sky-300" },
  google: { label: "Google Ads", cls: "bg-emerald-100 text-emerald-700 border-emerald-300" },
  direct: { label: "Direkt", cls: "bg-gray-100 text-gray-600 border-gray-300" },
};

export const inputCls =
  "w-full border border-[var(--line)] rounded-xl px-3.5 py-2.5 text-sm bg-white focus:border-[var(--terra)] outline-none transition-colors";
